
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class VideoSlide extends Vue {
  @Prop() enableScrollIndication!: boolean;
  @Prop() src!: string;
  @Prop() vtt!: string;
  @Prop({default: 'dark'}) backgroundTheme!: string;
  @Prop(String) hiddenTitle!: string;
  @Prop() disableAutoplay?: boolean;
  @Prop() showCaptionsByDefault?: boolean;
  @Prop({ default: false }) hideCaptionsButton!: boolean;

  handleSkipVideoControllers(){
    let transcriptButton = document.getElementById('transcriptButton');
    if(transcriptButton)
      return transcriptButton.focus();

    let nextButton = document.getElementById('nextButton');
    if(nextButton)
      return nextButton.focus();

    let previewButton = document.getElementById('previewButton');
    if(previewButton)
      return previewButton.focus();
  }
}
